import React, { useState } from 'react';
import TileItem from './TileItem';

const Tiles = ({ className, onColorSelect, data }) => {
  const [selected, setSelected] = useState(-1);

  const handleSelect = (index) => {
    setSelected(index);
    onColorSelect(index);
  };
  return (
    <section className={`hair-quiz-template ${className || ''}`}>
      <ul className="list-reset list-colors">
        {data.map((item, index) => {
          const active = index === selected;
          return (
            <TileItem
              key={`${index}-${+active}`}
              active={active}
              onClick={() => handleSelect(index)}
              squareSrc={item.square}
            />
          );
        })}
      </ul>
    </section>
  );
};

export default Tiles;
